import React from "react";

function BalCom() {
  return (
    <div className="py-5">
      <div className="row row-cols-1 row-cols-md-2">
        <div className="col">
          <h2 className="text-h-m-orange">Balochistan</h2>
          <br />
          <br />
          <h2 className="text-h-black">Living with Nothing</h2>
          <br />
          <br />
          <br />
          <br />
          <p>
            A series of security operations have punctuated Balochistan’s
            amalgamation as Pakistan’s fourth province — with the first in 1948,
            then across the 1960s and 1970s, and the last in 2002, to suppress
            insurgencies against state control of territory and resources. Bar
            the occasional lull over the years, such troubles have resurfaced
            without fail, triggering a harsh response from the state to crush
            insurgencies and activism. Consequently, the province’s relationship
            with the centre is a complicated one, marked by a deep sense of
            disaffection flowing from the state’s cavalier attitude to its
            grievances and concerns over the years.
          </p>
          <p>
            Given this context, it comes as a surprise that the province’s jails
            are not crowde, when compared with prisons in the rest of the
            country. NACTA’s 2018 study on overcrowding in jails reports a total
            housing capacity of 2,585 prisoners, making Balochistan the only
            province whose correctional facilities do not suffer from
            overcrowding. According to the 2021 Federal Ombudsman Report, there
            were 2,526 prisoners spread across 11 prisons in Balochistan.
          </p>
        </div>
        <div className="col">
          <img
            style={{ width: "100%", height: "100%" }}
            src={require("../../assets/images/balochistan-map.png")}
            alt="balochistan-map"
          />
        </div>
      </div>
    </div>
  );
}

export default BalCom;
